<template>
    <transition name="modal-fade">

        <div class="c-modal-backdrop">
            <div class="c-modal" tabindex="-1" role="dialog">
                <div class="c-modal__dialog c-modal__dialog--centered" role="document">
                    <div class="c-modal__content">

                        <div class="c-modal__header">
                            <div>
                                <slot name="header" />
                            </div>
                            <a href="#0" class="c-modal__close" @click.prevent="close">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 9.045 9.045">
                                    <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2">
                                        <path d="M1.415 1.414L7.63 7.631"/>
                                        <path d="M7.632 1.414L1.415 7.631"/>
                                    </g>
                                </svg>
                            </a>
                        </div>

                        <div class="c-modal__body">
                            <slot name="body" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--<div class="c-modal-backdrop" v-on:toggle-modal="modalIsOpen = true" key="modal-backdrop"></div>-->
    </transition>
</template>

<script>
    export default {
        name: 'Modal',
        // props: ['title', 'location'],
        data () {
            return {
                modalIsOpen: false,
            };
        },
        methods: {
            close () {
                this.$emit('close');
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../assets/scss/_essentials.scss";

    .modal-fade-enter,
    .modal-fade-leave-active {
        opacity: 0;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity .5s ease-in-out;
    }

    .c-modal {
        @include fixed(top 0 left 0);
        @include square(100%);
        overflow: hidden;
        outline: 0;
        z-index: $zindex-modal;

        // elements

        &__dialog {
            position: relative;
            margin: grid(2);
            // transform: translate(0, -100%);
            // transition: transform .3s ease-out;
            // height: calc(100% - #{rem(20)});
            // width: 100%;

            @include media-breakpoint-up(sm) {
                margin: grid(2, sm) auto;
                // height: 100%;
                width: 67%;
            }

            @include media-breakpoint-up(md) {
                width: 50%;
            }

            @include media-breakpoint-up(lg) {
                width: grid(14, lg);
            }

            &--scrollable {
                display: flex;
                max-height: calc(100% - #{$modal-dialog-margin * 2});

                .c-modal__content {
                    max-height: calc(100vh - #{$modal-dialog-margin * 2});
                    overflow: hidden;
                }
            }

            &--centered {
                display: flex;
                align-items: center;
                min-height: calc(100% - #{$modal-dialog-margin * 2});

                &::before {
                    display: block;
                    height: calc(100vh - #{$modal-dialog-margin * 2});
                    content: "";
                }

                &.modal-dialog--scrollable {
                    flex-direction: column;
                    justify-content: center;
                    height: 100%;

                    .c-modal__content {
                        max-height: none;
                    }

                    &::before {
                        content: none;
                    }
                }
            }

            &--video {

            }
        }

        &__content {
            border-radius: grid(1);
            box-shadow: 0 rem(5) rem(30) rgba($brand-primary, .1);
            position: relative;
            display: flex;
            flex-direction: column;
            background-color: $modal-content-bg;
            background-clip: padding-box;
            outline: 0;
            overflow: hidden;
            height: 100%;
            width: 100%;
        }

        &__header {
            // @include fixed(top 0 left 0 right 0);
            display: flex;
            // align-items: center; // vertically center it
            justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends
            // background-color: $gray-lightest;
            padding: grid(2) grid(2) 0;
            z-index: 5;

            @include media-breakpoint-up(lg) {
                padding: grid(1, lg) grid(1, lg) 0;
            }

            .c-modal__dialog--video & {
                background-color: $white;
            }
        }

        &__title {
            color: $text-color;
            line-height: 1;
            margin-bottom: 0;
        }

        &__body {
            position: relative;
            // Enable `flex-grow: 1` so that the body take up as much space as possible
            // when should there be a fixed height on `.modal-dialog`.
            flex: 1 1 auto;
            padding: grid(2);

            @include media-breakpoint-up(lg) {
                padding: grid(1, lg)
            }

            .c-modal__dialog--video & {
                align-items: center;
                background-color: $gray-lightest;
            }
        }

        &__close {
            @include square(rem(12));
            @include flex-center;
            color: $brand-danger;
        }

        // extras

        &-backdrop {
            @include fixed-fill;
            background-color: rgba($gray-darker, .5);
            z-index: $zindex-modal-backdrop;
        }
    }
</style>
